export const SALES_OPS = "Admin";
export const SALES_REP = "User";
export const SALES_MGR = "User";

export const DASHBOARD_FROM_DATE = 0;
export const DASHBOARD_TO_DATE = 6;

export const SOW = "Statement of Work";
export const QTE = "Quote/Order Form";
export const SLA = "Service Contract/SLA";
export const MSA = "Master Service Agreement";
export const DPA = "Data Processing Agreement";
export const NDA = "Non Disclosure Agreement";
export const CSA = "Cloud Service Agreement";
export const SAQ = "Security Assessment Questionnaire";

export const DOCUMENT_TYPES_HASMAP = {
  [SOW]: "SOW",
  [QTE]: "Quote",
  [SLA]: "SLA",
  [MSA]: "MSA",
  [DPA]: "DPA",
  [NDA]: "NDA",
  [CSA]: "CSA",
  [SAQ]: "SAQ",
};

export const DASHBOARD_DOC_STATUS = [
  {
    status: "DRAFT",
    frequency: 0,
    dealValue: 0,
  },
  {
    status: "PENDING_APPROVAL",
    frequency: 0,
    dealValue: 0,
  },
  {
    status: "APPROVED",
    frequency: 0,
    dealValue: 0,
  },
  {
    status: "SENT_TO_CLIENT",
    frequency: 0,
    dealValue: 0,
  },
  {
    status: "DOCUMENT_CLIENT_APPROVED",
    frequency: 0,
    dealValue: 0,
  },
  {
    status: "DOCUMENT_CLIENT_REJECTED",
    frequency: 0,
    dealValue: 0,
  },
  {
    status: "DOCUMENT_CLIENT_SIGNED",
    frequency: 0,
    dealValue: 0,
  },
];

export const DASHBOARD_DOC_TYPES = [
  {
    name: SOW,
    frequency: 0,
  },
  {
    name: QTE,
    frequency: 0,
  },
  {
    name: SLA,
    frequency: 0,
  },
  {
    name: MSA,
    frequency: 0,
  },
  {
    name: DPA,
    frequency: 0,
  },
  {
    name: NDA,
    frequency: 0,
  },
  {
    name: CSA,
    frequency: 0,
  },
  {
    name: SAQ,
    frequency: 0,
  },
];

const CHART_FONT_FAMILIES =
  "system-ui, -apple-system, BlinkMacSystemFont, 'Helvetica Neue', 'Lucida Grande', 'Segoe UI'";

export const PIE_CHART_CONFIGS = {
  type: "doughnut2d",
  dataFormat: "JSON",
  dataSource: {
    chart: {
      baseFont: CHART_FONT_FAMILIES,
      outCnvBaseFont: CHART_FONT_FAMILIES,
      showpercentvalues: "1",
      decimals: "1",
      theme: "fusion",
      enableSmartLabels: "0 ",
      showPercentageInLabel: "0",
      showLabels: "0",
      showValues: "0",
      pieRadius: "80",
      labelFontSize: "10",
      doughnutRadius: "60",
    },
    data: [],
  },
};

export const SCROLL_STACKED_COLUMN_CHART_CONFIGS = {
  type: "scrollstackedcolumn2d",
  dataFormat: "JSON",
  dataSource: {
    chart: {
      baseFont: CHART_FONT_FAMILIES,
      outCnvBaseFont: CHART_FONT_FAMILIES,
      scrollheight: "10",
      flatscrollbars: "0",
      numvisibleplot: "8",
      theme: "fusion",
      showlegend: "0",
      numberPrefix: "$",
      captionOnTop: 0,
      captionFontSize: "14",
      captionFontColor: "#586986",
      captionPadding: "25",
      chartBottomMargin: "-10",
      paletteColors: "#5d62b5, #ffbac0",
      scrollToEnd: "1",
      scrollPadding: "10",
      maxColWidth: "30",
    },
    categories: [],
    dataset: [],
  },
};

export const BAR_CHART_CONFIGS = {
  type: "bar2d",
  dataFormat: "JSON",
  dataSource: {
    chart: {
      theme: "fusion",
      baseFont: CHART_FONT_FAMILIES,
      outCnvBaseFont: CHART_FONT_FAMILIES,
      numDivLines: "1",
      maxBarHeight: "30",
    },
    data: [],
  },
};

export const COLUMN_CHART_CONFIGS = {
  type: "column2d",
  dataFormat: "JSON",
  dataSource: {
    chart: {
      theme: "fusion",
      baseFont: CHART_FONT_FAMILIES,
      outCnvBaseFont: CHART_FONT_FAMILIES,
      showlegend: "0",
      captionOnTop: 0,
      captionFontSize: "14",
      captionFontColor: "#586986",
      chartBottomMargin: "-2",
      paletteColors: "#5d62b5",
      maxColWidth: "30",
    },
    data: [],
  },
};

export const MonthToDigitMap = {
  1: "Jan",
  2: "Feb",
  3: "Mar",
  4: "Apr",
  5: "May",
  6: "Jun",
  7: "Jul",
  8: "Aug",
  9: "Sept",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const HIGH_VALUE_DEALS_TABLE_HEADER = [
  { label: "Account Name", className: "" },
  { label: "Opportunity", className: "" },
  { label: "Deal Size", className: "right-align" },
  { label: "Approvers", className: "center-align" },
  { label: "Turn Around Date", className: "center-align" },
];

export const ACCOUNTS_TABLE_HEADER = [
  { label: "Company Name", className: "" },
  { label: "Deal Value Closed", className: "right-align" },
  { label: "Pipeline value", className: "right-align" },
  { label: "Avg Discount", className: "center-align" },
  { label: "Opportunities", className: "center-align" },
];

export const LEADERBOARD_TABLE_HEADER = [
  { label: "Sales Rep", className: "" },
  { label: "Deal Value Closed", className: "leaderboard-dealth right-align" },
];

export const ACCOUNTS_TABLE_CHART = "ACCOUNTS";
export const HIGH_VALUE_DEALS_TABLE_CHART = "HIGH_VALUE_DEALS";
export const LEADERBOARD_TABLE_CHART = "LEADERBOARD";

export const TABLE_CHART_CONFIGS = {
  [ACCOUNTS_TABLE_CHART]: {
    headerTitle: "ACCOUNTS",
    tableHeadings: ACCOUNTS_TABLE_HEADER,
  },
  [HIGH_VALUE_DEALS_TABLE_CHART]: {
    headerTitle: "PENDING HIGH VALUE DEALS",
    tableHeadings: HIGH_VALUE_DEALS_TABLE_HEADER,
  },
  [LEADERBOARD_TABLE_CHART]: {
    headerTitle: "LEADERBOARD",
    tableHeadings: LEADERBOARD_TABLE_HEADER,
  },
};
